import angular from 'angular';

import CommentApiService from './comment-api.service';
import FileAPIService from './file-api.service';
import FuelApiService from './fuel-api.service';
import MonitoringAPIService from './monitoring-api.service';
import PrintAPIService from './print-api.service';
import SalesAPIService from './sales-api.service';
import SettingsAPIService from './settings-api.service';
import SurveyAPIService from './survey.service';
import UsersAPIService from './users-api.service';
import PlatformsAPIService from './platforms-api.service';
import AuthAPIService from './auth-api.service';
import SupportAPIService from './support-api.service';

export default angular.module('autoboard.api', [
  CommentApiService,
  FuelApiService,
  MonitoringAPIService,
  PrintAPIService,
  SalesAPIService,
  SettingsAPIService,
  SurveyAPIService,
  UsersAPIService,
  FileAPIService,
  PlatformsAPIService,
  AuthAPIService,
  SupportAPIService,
])
  .name;
